import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { getLocalStorage } from './web-storage';

export const PrivateRoute = ({ children }) => {
  const accessToken = getLocalStorage('accessToken');
  const location = useLocation();

  if (!accessToken) {
    // Redirect to login with current location
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const accessToken = getLocalStorage('accessToken');

  if (accessToken) {
    // Redirect to analytics if already logged in
    return <Navigate to="/analytics" replace />;
  }

  return children;
};
